/**
 * Caminho de arquivo estático que funciona no site e no app instalado.
 *
 * O código usava `${window.location.origin}/images/...`. Em `file://` — que é
 * como o app de Windows carrega — `origin` vale a string "null", e o caminho
 * virava "null/images/...". A logo simplesmente não aparecia nos relatórios, e
 * o `onerror` do <img> escondia a falha sem avisar ninguém.
 *
 * `new URL(rel, href)` resolve nos dois casos e devolve um endereço absoluto,
 * necessário porque os relatórios são escritos numa janela nova, cuja base
 * seria `about:blank`.
 */
export const assetUrl = (caminhoRelativo) => {
  const base = process.env.PUBLIC_URL || '';
  const rel = `${base}/${caminhoRelativo}`.replace(/\/{2,}/g, '/').replace(/^\//, '');
  return new URL(rel, window.location.href).href;
};

/**
 * A marca do sistema — uma só, em todo lugar.
 *
 * Já houve duas aqui: a do FIV Pro e a do laboratório. Não vale a pena manter
 * a distinção enquanto o valor é o mesmo nos dois casos — duas funções
 * devolvendo o mesmo arquivo só criam a chance de alguém trocar uma e esquecer
 * a outra. Nos relatórios o laboratório continua identificado pelo NOME, que
 * vem do cadastro e acompanha quem estiver logado; isso funciona com vários
 * laboratórios, e uma imagem fixa no `public/` nunca funcionou.
 *
 * PNG com fundo transparente e recortado justo na arte: o quadrado de 512 dos
 * ícones tem margem branca larga e apareceria pequeno, com um retângulo branco
 * por cima do fundo da tela.
 */
export const LOGO_URL = () => assetUrl('images/fivpro.png');
